import * as React from 'react'
// import { useStaticQuery, graphql } from "gatsby"
// import GravityFormForm from "gatsby-plugin-gravity-forms";

const Layout = () => {
// 	const data = useStaticQuery(graphql`
//     {
//         wpGfForm(databaseId: { eq: 1 }) {
// 			...GravityFormFields
// 		}
//     }
//   `)

	const handleSubmit = (event) => {
		event.preventDefault();
	
		const myForm = event.target;
		const formData = new FormData(myForm);
		
		fetch("/", {
		method: "POST",
		headers: { "Content-Type": "application/x-www-form-urlencoded" },
		body: new URLSearchParams(formData).toString(),
		})
		.then(function() {
			myForm.reset();
			document.getElementById("thankyou_message").style.display = "block";
			document.getElementById("formwrap").style.display = "none";
		})
		.catch((error) => alert(error));
	};
	if (typeof window !== 'undefined') {
		setTimeout(() => {
			document.querySelector("form").addEventListener("submit", handleSubmit);
		}, 1000);
	}

	return (
		// <GravityFormForm data={data}
		<div>
			<div id="formwrap">
				<form name="Contact" method="POST" data-netlify="true">
					<input type="hidden" name="form-name" value="Contact" />
					<div className='gform_fields'>
						<div className='gfield gatsbyHalf'>
							<label>Your Name* <input type="text" name="name" required /></label>
						</div>
						<div className='gfield gatsbyHalf'>
							<label>Your Email* <input type="email" name="email" required /></label>
						</div>
						<div className='gfield gatsbyFull'>
							<label>Message* <textarea name="message" required></textarea></label>
						</div>
						<button className='gravityform__button gform_button button' type="submit">Get in touch</button>
					</div>
				</form>
			</div>
			<div id="thankyou_message" style={{display: 'none'}}>
				<p>Thanks for contacting us! We will get in touch with you shortly.</p>
			</div>
		</div>
	)
}

export default Layout